export const cufrontLogos = {
  cufrontLogo: "https://cufront-assets.s3.amazonaws.com/logos/cufront+logo.svg",
  cufrontLogomark:
    "https://cufront-assets.s3.amazonaws.com/logos/cufront+logomark+.svg",
    cufrontLogomark2:"https://cufront-assets.s3.amazonaws.com/logos/cufront-logo.png"
};
